import { render, staticRenderFns } from "./ImgLySceneEditor.vue?vue&type=template&id=3d8ca72c&scoped=true"
import script from "./ImgLySceneEditor.vue?vue&type=script&lang=js"
export * from "./ImgLySceneEditor.vue?vue&type=script&lang=js"
import style0 from "./ImgLySceneEditor.vue?vue&type=style&index=0&id=3d8ca72c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8ca72c",
  null
  
)

export default component.exports